import FileManager from '@/components/file/manager'

export default function(h) {
  return h(FileManager)
}
